module.exports = __webpack_public_path__ + "static/media/Corona-banner.9a2cc49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/Corona-banner.png
// module id = 830
// module chunks = 0